<!-- OrderNav.vue -->
<template>
	<div class="order-wrapepr">
		<!-- header -->
		<div class="order-header">
			<ul>
				<li class="item"
					v-for="item in ORDERNAV"
					v-bind:key="item.id"
					v-bind:class="{'active': orderStatus == item.id}"
					v-on:click="setOrderNavActive(item.id)"
				>{{ item.name }}</li>
			</ul>
		</div>
		<!-- body -->
		<!-- 无限加载滚动列表 -->
		<!-- <div > -->
			<div v-infinite-scroll="getMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" class="order-body">
				<div v-if="orderList.length > 0 ">
					<div class="list" v-for="(item, index) in orderList" v-bind:key="item.id">
						<h3 class="title" v-if="item.status != 4">{{ getOrderStatusBy(item.status) }}</h3>
						<h3 v-if="item.status == 4">
							<img src="../../../assets/image/change-icon/e3_seal@2x.png">
						</h3>
						<div class="order-image" v-if="item.goods.length > 0"  @click="goOrderDetail(item.id)">
							<img v-bind:src="image.product.photos[0].thumb" v-for="image in item.goods" v-if='image.product.photos.length > 0' data-src='../../../assets/image/change-icon/default_image_02@2x.png'>
							<img src="../../../assets/image/change-icon/default_image_02@2x.png" v-for="image in item.goods" v-if='image.product.photos.length <= 0'>
              <div class="right-wrapper">
                <label class="title">{{item.goods[0].product.name}}</label>
                <label class="property" >{{item.goods[0].property}}</label>
                <div class="desc-wrapper" v-bind:class="{'propertyOrder': item.goods[0].property == ''}">
                  <!-- <label class="price" v-if="!item.extension_code">￥ {{utils.currencyPrice(item.goods[0].product_price)}}</label> -->
                  <!-- <label class="count">x{{item.goods[0].total_amount}}</label> -->
                </div>
              </div>
						</div>
						<div class="price">(共计{{item.goods.length}}件商品) 合计 : ￥ <i>{{item.total}}</i><i class="freight">(含运费:￥{{ item.shipping.price }})</i>
						</div>
						<div class="order-list-opratio">
							<!-- 待付款 -->
							<div class="btn" v-if="item.status == 0">
								<button v-on:click="cancel()">取消订单</button>
								<mt-popup v-model="popupVisible" position="bottom" class="mint-popup">
									<div class="cancels">
										<div class="cancelInfo">
											<span class="cancel" v-on:click="cancelInfo()">取消</span>
											<span class="success" v-on:click="complete(item.id, index)">完成</span>
										</div>
										<div class="reason">
											<p v-for="(item, list) in reasonList" v-bind:key="list" v-on:click="getReasonItem(item)">{{item.name }} </p>
										</div>
									</div>
								</mt-popup>
								<button class="buttonright" v-on:click="payment(item)">去支付</button>
							</div>
							<!-- 待发货 -->
							<div class="btn"  v-if="item.status == 1 ? '':checkState">

							</div>
							<!-- 发货中 -->
							<div class="btn"  v-if="item.status == 2">
								<button v-on:click="track(item.id)">查看物流</button>
								<button class="buttonright" v-on:click="confirm(item,index)">确认收货</button>
							</div>
							<!-- 待评价 -->
							<div class="btn" v-if="item.status == 3" >
								<button v-on:click="goComment(item)">评价晒单</button>
							</div>
							<!-- 配货中 -->
							<div class="btn" v-if="item.status == 6" >
								<button v-on:click="track(item.id)">查看物流</button>
								<button class="buttonright" v-on:click="confirm(item,index)">确认收货</button>
							</div>
						</div>
					</div>
					<div class="loading-wrapper">
						<p v-if='!isMore'>没有更多了</p>
					</div>
				</div>
				<div class="order-air" v-if="orderList.length <= 0 && !isMore">
					<img src="../../../assets/image/change-icon/empty_order@2x.png">
					<p>您的订单为空</p>
					<button class="button" v-on:click="goVisit()">
						<label>随便逛逛</label>
					</button>
				</div>
			</div>
		<!-- </div> -->
	</div>
</template>

<script>
import { ORDERSTATUS, ORDERNAV } from '../static';
import { Toast } from 'mint-ui';

import {
  orderList,
  orderCancel,
  orderReasonList,
  orderConfirm,
  orderRebuy
} from '../../../api/order'; //订单列表  //取消订单 //获取退货原因 //确认收货 //再次购买
import { Indicator, MessageBox, Popup } from 'mint-ui';
import OrderNav from './OrderNav';
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'page-navbar',
  data() {
    return {
      ORDERNAV: ORDERNAV,
      ORDERSTATUS: ORDERSTATUS,
      orderListParams: { page: 0, per_page: 10, status: '' },
      orderList: [],
      loading: false,
      orderCancel: [],
      isMore: true,
      popupVisible: false,
      slots: [
        {
          flex: 1,
          values: [
            '不想要了',
            '支付不成功',
            '价格较贵',
            '缺货',
            '等待时间过长'
          ],
          className: 'slot1',
          textAlign: 'center'
        }
      ],
      reasonList: [],
      success: [],
      reasonId: '',
      message: '',
      checkState: ''
    };
  },
  created() {
    this.getUrlParams();
    this.orderReasonList();
  },
  computed: {
    ...mapState({
      orderStatus: state => state.order.orderStatus,
      orderItem: state => state.order.orderItem
    })
  },
  methods: {
    ...mapMutations({
      changeStatus: 'changeStatus',
      changeItem: 'changeItem'
    }),

    getUrlParams() {
      let status = this.$route.params.order;
      let index = this.orderStatus;
      if (status == null) {
        this.changeStatus(status);
      } else {
        this.changeStatus(index);
      }
    },
    // 去订单详情
    goOrderDetail(id) {
      this.$router.push({ name: 'orderDetail', query: { id: id } });
    },

    setOrderNavActive(index) {
      this.orderListParams.page = 1;
      this.orderList = [];
      this.changeStatus(index);
      this.getOrderList();
    },

    // 获取订单列表
    getOrderList(ispush) {
       Indicator.open();
      let data = this.orderListParams;
      data.status = this.orderStatus;
      orderList(data.page, data.per_page, data.status).then(res => {
        if (res) {
          if (ispush) {
            this.orderList = this.orderList.concat(res.orders);
          } else {
            this.orderList = res.orders;
          }
          this.isMore = res.paged.more == 1 ? true : false;
          // this.loading = true;
          Indicator.close();
        }
      });
    },

    // 根据订单状态值获取对应的状态
    getOrderStatusBy(status) {
      let data = this.ORDERSTATUS;
      for (let i = 0, len = data.length; i <= len - 1; i++) {
        if (data[i].id == status) {
          return data[i].name;
        }
      }
    },
    //  加载更多数据
    getMore() {
      this.loading = true;
      this.orderListParams.page = ++this.orderListParams.page;
      if (this.isMore) {
        this.loading = false;
        console.log(this.isMore);
        this.getOrderList(true);
      }
    },

    // 取消订单
    cancel() {
      this.popupVisible = true;
      this.stop();
    },
    cancelInfo() {
      this.popupVisible = false;
      this.move();
    },
    complete(id, index) {
      this.popupVisible = false;
      this.getordersuccess(id, index);
      this.move();
    },

    /***滑动限制***/
    stop() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', mo, false); //禁止页面滑动
    },
    /***取消滑动限制 ***/
    move() {
      var mo = function(e) {
        e.preventDefault();
      };
      document.body.style.overflow = ''; //出现滚动条
      document.removeEventListener('touchmove', mo, false);
    },

    // 查看物流
    track(id) {
      this.$router.push({ name: 'orderTrack', params: { orderTrack: id } });
    },
    // 去支付
    payment(order) {
      this.$router.push({ name: 'payment', query: { order: order.id, total: order.total } });
    },
    // 随便逛逛
    goVisit() {
      this.$router.push('/home');
    },
    // 确认收货
    confirm(item, index) {
      MessageBox.confirm('是否确认收货？', '确认收货').then(action => {
        this.changeItem(item);
        this.orderConfirms(item.id, index);
        this.$router.push({ name: 'orderTrade', query: { id: item.id } });
      });
    },
    // 获取确认收货数据
    orderConfirms(id, index) {
      orderConfirm(id).then(res => {
        if (res) {
          this.orderList[index] = res.order;
        }
      });
    },

    // 获取再次购买数据
    goBuy(id) {
      Indicator.open({
        spinnerType: 'fading-circle'
      });
      orderRebuy(id).then(res => {
        if (res) {
          Indicator.close();
          this.$router.push('/cart');
        }
      });
    },

    // 晒单评价
    goComment(item) {
      this.changeItem(item);
      this.$router.push({ name: 'orderComment', query: { order: item.id } });
    },

    // 获取退货原因数据
    orderReasonList() {
      orderReasonList().then(res => {
        if (res) {
          this.reasonList = Object.assign([], this.reasonList, res.reasons);
        }
      });
    },
    // 获取取消订单数据
    getordersuccess(id, index) {
      orderCancel(id, this.reasonId).then(res => {
        if (res) {
          this.orderList = [];
          this.getOrderList();
        }
      });
    },
    //
    getReasonItem(item) {
      this.reasonId = item.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.order-wrapepr {
  height: 100%;
  .order-header {
    position: fixed;
    height: 44px;
    width: 100%;
    top: 44px;
    z-index: 100;
    ul {
      list-style: none;
      width: auto;
      display: flex;
      justify-content: space-around;
      align-content: center;
      align-items: center;
      height: 100%;
      background: rgba(255, 255, 255, 1);
      border-bottom: 1px solid #e8eaed;
      li {
        font-size: 14px;
        font-family: 'PingFangSC-Regular';
        color: rgba(124, 127, 136, 1);
        height: 100%;
        text-align: center;
        line-height: 44px;
        border-bottom: 2px solid transparent;
        &.active {
          color: $primaryColor;
          border-bottom-color: $primaryColor;
        }
      }
    }
  }
  .order-body {
    overflow: auto;
    height: 100%;
    position: absolute;
    width: 100%;
    top: 89px;
    .list {
      width: 100%;
      margin-top: 11px;
      h3 {
        padding: 0px;
        margin: 0px;
        font-size: 14px;
        font-family: 'PingFangSC-Regular';
        color: rgba(124, 127, 136, 1);
        line-height: 44px;
        height: 44px;
        text-align: right;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0.5px 0px 0px rgba(232, 234, 237, 1);
        padding: 0px 15px 0px 10px;
        img {
          width: 76px;
          height: 60px;
        }
      }
      .order-image {
        height: 91px;
        background: rgba(250, 250, 250, 1);
        width: 100%;
        overflow: auto;
        white-space: nowrap;
        float: left;
        img {
          float: left;
          width: 60px;
          height: 60px;
          border-radius: 1px;
          margin: 17px 10px 10px;
        }
        .right-wrapper {
          float: left;
          padding: 17px 10px 10px;
          overflow: hidden;
        }
        .title {
          margin-top: 15px;
          color: #4e545d;
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .property {
          font-size: 14px;
          color: #7c7f88;
          padding-top: 10px;
        }
        .count {
          margin-top: 4px;
          color: #7c7f88;
          font-size: 13px;
          margin-right: 10px;
        }
        .desc-wrapper {
          height: 20px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding-top: 21px;
        }
      }
      .price {
        font-size: 14px;
        font-family: 'PingFangSC-Regular';
        color: rgba(78, 84, 93, 1);
        line-height: 44px;
        height: 44px;
        background-color: #fff;
        padding: 0px 15px 0px 0px;
        border-bottom: 1px solid $lineColor;
        box-sizing: border-box;
        text-align: right;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        i {
          font-size: 19px;
          padding-left: 5px;
          font-style: normal;
          &.freight {
            color: rgba(124, 127, 136, 1);
            font-size: 12px;
          }
        }
      }
      .btn {
        height: 44px;
        display: flex;
        justify-content: flex-end;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        button {
          width: 90px;
          height: 30px;
          font-size: 14px;
          border-radius: 2px;
          margin: 7px 15px 7px 0px;
          background-color: #fff;
          border: 1px solid #ccc;
        }
        .buttonright {
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          color: $primaryColor;
          border: 1px solid $primaryColor;
        }
      }
    }
    .loading-wrapper {
      text-align: center;
      p {
        color: #7c7f88;
        font-size: 12px;
        font-weight: 'Regular';
        margin: 10px auto;
      }
    }
  }
  .order-air {
    width: 100%;
    vertical-align: middle;
    text-align: center;
    img {
      width: 76px;
      height: 76px;
      box-sizing: border-box;
      margin: 120px auto 30px;
    }
    p {
      font-size: 17px;
      font-family: 'PingFangSC-Regular';
      color: rgba(124, 127, 136, 1);
      line-height: 17px;
      margin-top: 30px;
      text-align: center;
      margin: 0 auto;
    }
    .button {
      width: 200px;
      height: 44px;
      background: $primaryColor;
      border-radius: 2px;
      padding: 14px 68px;
      margin: 28px auto;
      border: none;
    }
    label {
      font-size: 16px;
      color: #fff;
      display: inline-block;
      vertical-align: middle;
      height: 16px;
      line-height: 16px;
    }
  }
  .mint-popup {
    width: 100%;
    height: 235px;
  }
  .cancels {
    height: 100%;
    .cancelInfo {
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      border-bottom: 1px solid #F0F0F0;
      span {
        color: #000;
        font-size: 14px;
      }
      .cancel {
        padding: 10px 15px;
      }
      .success {
        padding: 10px 15px;
      }
    }
    .reason {
      margin-top: 10px;
      p {
        height: 16px;
        line-height: 16px;
        text-align: center;
        padding: 10px;
        &:hover {
          color: red;
        }
      }
    }
  }
  .show-product-model {
    background: rgba(0, 0, 0, 0.5);
    overflow: hidden;
    height: 100%;
    position: fixed;
    top: 100px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }
}
</style>






// WEBPACK FOOTER //
// src/page/order/child/OrderNav.vue